import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/vip_charge_stations',
  component: Management,
  redirect: '/vip_charge_stations/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/vip_charge_stations/List'),
      redirect: 'list/vip_charge_stations',
      meta: {
        auth: Auth.listVipChargeStations
      },
      children: [
        {
          path: 'list_table',
          component: () => import('@/views/vip_charge_stations/ListTable'),
          meta: {
            auth: Auth.listVipChargeStations,
            tabName: 'list_table'
          }
        }
      ]
    },
    //新增页
    {
      path: 'new',
      component: () => import('@/views/vip_charge_stations/New'),
      meta: {
        auth: Auth.createVipChargeStation,
        tabName: 'new'
      }
    }
  ]
}
